import React, { Component } from "react";
import Grid from "@mui/material/Grid";
import ClipLoader from "react-spinners/ClipLoader";
import { connect } from "react-redux";
import { Line } from "./Line";
import { reportError } from "../actions/erroractions";

class PlaySample extends Component {
  state = {
    play: false,
    loading: false,
    currentTime: 0.0,
    audioSrc: null,
  };

  constructor() {
    super();

    this.player = React.createRef(null);
    this.bar = React.createRef(null);

    this.play = this.play.bind(this);
    this.pause = this.pause.bind(this);
    this.renderPlayPause = this.renderPlayPause.bind(this);
    this.stopLoading = this.stopLoading.bind(this);
    this.startLoading = this.startLoading.bind(this);
    this.timeUpdate = this.timeUpdate.bind(this);
    this.renderBar = this.renderBar.bind(this);
    this.moveSong = this.moveSong.bind(this);
    this.secondToMinutesSeconds = this.secondToMinutesSeconds.bind(this);
    this.playError = this.playError.bind(this);

    this.fetchAudioWithRange = this.fetchAudioWithRange.bind(this);
  }
  

  async componentDidMount() {
    this.player.current.volume = 0.1;
    this.player.current.addEventListener("loadstart", this.startLoading);
    this.player.current.addEventListener("canplay", this.stopLoading);
    await this.fetchAudioWithRange();
    this.player.current.addEventListener("error", this.playError);
  }

  componentWillUnmount() {
    // Clean up blob URL
    if (this.state.audioSrc) {
      URL.revokeObjectURL(this.state.audioSrc);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const uniqueNameCurrent = this.props.uniqueName;
    const songsCurrent = this.props.songs;
    const uniqueNameLast = prevProps.uniqueName;
    const songsLast = prevProps.songs;

    if (uniqueNameCurrent === uniqueNameLast) {
      const songCurrent = songsCurrent[uniqueNameCurrent];
      const songLast = songsLast[uniqueNameLast];

      if (songCurrent.sampleStartByte !== songLast.sampleStartByte) {
        this.pause();
        this.fetchAudioWithRange();
      }
    }
  }

  async fetchAudioWithRange() {
    const { uniqueName, songs, dispatch } = this.props;
    const song = songs[uniqueName];
    try {
      this.startLoading();
      
      const response = await fetch(song.songUrl, {
        headers: {
          'Range': `bytes=${song.sampleStartByte}-${song.sampleEndByte}`
        }
      });
      
      if (!response.ok) {
        throw new Error('Failed to fetch audio');
      }
      
      const audioBlob = await response.blob();
      const blobUrl = URL.createObjectURL(audioBlob);
      
      // Clean up old blob URL if it exists
      if (this.state.audioSrc) {
        URL.revokeObjectURL(this.state.audioSrc);
      }
      
      this.setState({ audioSrc: blobUrl });
      
    } catch (error) {
      console.error('Error fetching audio:', error);
      dispatch(reportError("Unable to load song"));
      this.stopLoading();
    }
  }

  play() {
    this.player.current.play();
    this.setState({
      play: true,
    });
  }

  pause() {
    this.player.current.pause();
    this.setState({
      play: false,
    });
  }

  renderPlayPause() {
    const { play, loading } = this.state;

    if (loading) {
      return (
        <ClipLoader color="#FFFFFF" sizeUnit={"%"} size={100} loading={true} />
      );
    } else if (!play) {
      return (
        <img
          src="https://img.icons8.com/nolan/64/play.png"
          className="icon_button"
          onClick={this.play}
          alt={"Play"}
        />
      );
    } else {
      return (
        <img
          src="https://img.icons8.com/nolan/64/pause.png"
          className="icon_button"
          onClick={this.pause}
          alt={"Pause"}
        />
      );
    }
  }

  playError() {
    const { dispatch} = this.props;
    dispatch(reportError("Unable to play song"));
    this.stopLoading();
  }

  stopLoading() {
    this.setState({
      loading: false,
    });
  }

  startLoading() {
    this.setState({
      loading: true,
    });
  }

  timeUpdate() {
    this.setState({
      currentTime: this.player.current.currentTime,
    });
  }

  moveSong(e) {
    const { songs, uniqueName } = this.props;
    const { play } = this.state;

    const song = songs[uniqueName];
    const duration = song.endSecond - song.startSecond;

    const clientX = e.clientX;
    var rect = this.bar.current.getBoundingClientRect();
    var x = clientX - rect.left;

    const size = this.bar.current.clientWidth;

    const percentage = x / size;

    this.player.current.pause();

    console.log(`Start Second ${song.startSecond} - End Second ${song.endSecond} - Percentage ${percentage}`)

    this.player.current.currentTime = percentage * duration;

    this.timeUpdate();

    if (play) {
      this.player.current.play();
    }
  }

  secondToMinutesSeconds(seconds) {
    const minutes = Math.floor(seconds / 60);
    let remainderSeconds = Math.round(seconds % 60);

    if (remainderSeconds < 10 && minutes > 0) {
      remainderSeconds = "0" + remainderSeconds;
    }

    if (minutes === 0) {
      return `${remainderSeconds}`;
    }

    return `${minutes}:${remainderSeconds}`;
  }

  renderBar(song) {
    const { currentTime } = this.state;

    let size;

    const duration = song.endSecond - song.startSecond;
    if (this.player.current) {
      size = 100 * (currentTime / duration);
    } else {
      size = 0;
    }

    return (
      <Grid item xs={10}>
        <div
          ref={this.bar}
          onClick={this.moveSong}
          style={{
            display: "flex",
            flexDirection: "row",
            marginLeft: "15%",
            marginRight: "15%",
          }}
        >
          <Line color="rgba(48, 155, 155, 0.54)" size={`${size}%`} />
          <Line color="#7F3FBF" size={`${100 - size}%`} />
        </div>
      </Grid>
    );
  }

  render() {
    const { uniqueName, songs } = this.props;
    const { audioSrc } = this.state;

    const song = songs[uniqueName];

    return (
      <Grid container direction="row" alignItems="center" justifyContent="center">
        <Grid item xs={1}>
          <p>{this.secondToMinutesSeconds(song.startSecond)}</p>
        </Grid>
        {this.renderBar(song)}
        <Grid item xs={1}>
          <p>{this.secondToMinutesSeconds(song.endSecond)}</p>
        </Grid>
        <Grid item xs={6}>
          {this.renderPlayPause()}
          <audio
            ref={this.player}
            //onEnded={this.pause}
            onTimeUpdate={this.timeUpdate}
            src={`${audioSrc}`}
            type="audio/mp3"
          />
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => ({
  songs: state.songs.songs,
});

export default connect(mapStateToProps)(PlaySample);
